/*******************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 * Copyright 2022 Adobe
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 ******************************************************************************/
import { FunctionComponent, JSXElementConstructor } from "react";

type ConditionalWrapperProps<P = any> = {
  condition: boolean;
  wrapperComponent: JSXElementConstructor<P>;
  wrapperProps: P;
};

export const ConditionalWrapper: FunctionComponent<ConditionalWrapperProps> = (
  props
) => {
  const WrapperComponent = props.wrapperComponent;
  return props.condition ? (
    <WrapperComponent {...props.wrapperProps}>
      {props.children}
    </WrapperComponent>
  ) : (
    <>{props.children}</>
  );
};
